import { coreOrganizationsAllGetAsyncSlice } from './get';
import { CoreOrganizationsAllName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { OrganizationMetadata } from '@types';
import { PatchOrganizationRequest } from '@api';

export const coreOrganizationsAllUpdateSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreOrganizationsAllName,
	state: coreOrganizationsAllGetAsyncSlice.asyncState,
	target: (request: PatchOrganizationRequest) => (organization) => organization.id === request.organizationId,
	update: (request: PatchOrganizationRequest) => (organization) => {
		const organizationAddition: Partial<OrganizationMetadata> = {};

		if (request) {
			const { dailySyncEnabled, name: requestName, packageTagEnabled } = request;

			if (typeof dailySyncEnabled === 'boolean') {
				organizationAddition.dailySyncEnabled = dailySyncEnabled;
			}
			if (requestName) {
				organizationAddition.name = requestName;
			}
			if (typeof packageTagEnabled === 'boolean') {
				organizationAddition.packageTagEnabled = packageTagEnabled;
			}
		}

		return {
			...organization,
			...organizationAddition
		};
	}
});
